import {
  Linking9142B,
  Linking9142C,
  Linking9035,
  Linking9089,
  Linking9142A,
} from "./forms";
// does 9035 need all of these fields? double check
export const LinkingResolver = (form_id) => {
  const obj = {
    "9142B": Linking9142B,
    "9142C": Linking9142C,
    9035: Linking9035,
    9089: Linking9089,
    "9142A": Linking9142A,
  };
  return obj[form_id] || undefined;
};
export const PWDResolver = (form_id) => {
  const obj = {
    "9142B": "9141",
    "9142C": "9141C",
    9035: "9141",
    9089: "9141",
    "9142A": "790A",
  };
  return obj[form_id] || undefined;
};
